var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 24,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "42940d8049"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 179 361.128906 L 572.710938 361.128906 L 572.710938 388.878906 L 179 388.878906 Z M 179 361.128906 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#42940d8049)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 558.804688 388.8125 L 192.910156 388.8125 C 185.414062 388.8125 179.359375 382.761719 179.359375 375.261719 C 179.359375 367.765625 185.414062 361.710938 192.910156 361.710938 L 558.804688 361.710938 C 566.304688 361.710938 572.355469 367.765625 572.355469 375.261719 C 572.355469 382.761719 566.304688 388.8125 558.804688 388.8125 Z M 558.804688 388.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessWhite);
export default __webpack_public_path__ + "static/media/less_white.f4e65f38063ca4dac863d51d2cb68c5f.svg";
export { ForwardRef as ReactComponent };